module.exports = __webpack_public_path__ + "img/arrow-square-up.e0adb8d7.svg";